import { api } from "../../lib/api";
import { useI18n } from "../../i18n/I18nProvider";
import { toast } from "sonner";
import { Package, ShoppingCart } from "lucide-react";

export default function RolePicker({ user, setUser }) {
  const { t } = useI18n();
  const pick = async (role) => {
    try {
      const { data } = await api.post("/auth/role", { role });
      setUser(data);
      toast.success(`${t("dash.roleSet")} ${t(`role.${role}`)}`);
    } catch {
      toast.error(t("dash.roleFail"));
    }
  };

  return (
    <div className="max-w-[900px] mx-auto px-6 pt-16">
      <div className="label-tech">{t("dash.welcome")} {user.name} ]</div>
      <h1 className="font-display text-4xl md:text-5xl font-medium tracking-tighter mt-2">{t("dash.pickRole")}</h1>
      <p className="text-[var(--ink-700)] mt-3 max-w-lg">{t("dash.pickRoleBody")}</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[var(--ink-200)] border border-[var(--ink-200)] mt-8">
        <button onClick={() => pick("seller")} className="bg-[var(--surface)] p-8 text-left hover:bg-[var(--surface-alt)] transition-colors" data-testid="role-seller-btn">
          <Package size={28} strokeWidth={1.5} />
          <div className="font-display text-2xl mt-4">{t("dash.iamSeller")}</div>
          <p className="text-[var(--ink-700)] mt-2 text-sm">{t("dash.iamSellerBody")}</p>
        </button>
        <button onClick={() => pick("buyer")} className="bg-[var(--surface)] p-8 text-left hover:bg-[var(--surface-alt)] transition-colors" data-testid="role-buyer-btn">
          <ShoppingCart size={28} strokeWidth={1.5} />
          <div className="font-display text-2xl mt-4">{t("dash.iamBuyer")}</div>
          <p className="text-[var(--ink-700)] mt-2 text-sm">{t("dash.iamBuyerBody")}</p>
        </button>
      </div>
    </div>
  );
}
